import React from 'react'
import Container from '../foundations/Container'
import Media from '../primitives/Media'
import { MEDIA_POLICY_KEYS } from '../primitives/mediaPolicy'
import styles from './ServiceOverview.module.scss'

const ContentBlocks = ({ blocks, className = '' }) => {
  const items = (Array.isArray(blocks) ? blocks : [blocks]).filter(Boolean)

  if (!items.length) return null

  return (
    <div className={className}>
      {items.map((block, index) => React.isValidElement(block)
        ? React.cloneElement(block, { key: block.key || `content-block-${index}` })
        : <p key={`content-block-${index}`}>{block}</p>)}
    </div>
  )
}

const ServiceOverview = ({ content, supportingContent }) => {
  if (!content?.heading) return null

  const {
    id = 'service-overview',
    eyebrow,
    heading,
    body,
    density = 'standard',
    guide,
    headingLevel = 'h2',
    media,
  } = content
  const Heading = headingLevel === 'h3' ? 'h3' : 'h2'
  const GuideHeading = headingLevel === 'h3' ? 'h4' : 'h3'
  const headingId = `${id}-heading`
  const guideHeadingId = guide?.heading ? `${id}-guide-heading` : undefined
  const hasMedia = Boolean(media?.src || media?.picture)

  return (
    <section className={styles.section} id={id} aria-labelledby={headingId}>
      <Container width='wide'>
        <div className={`${styles.frame} ${hasMedia ? '' : styles.textOnly} ${styles[density] || ''}`.trim()}>
          <article className={styles.introduction}>
            {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
            <Heading id={headingId}>{heading}</Heading>
            <ContentBlocks blocks={body} className={styles.introductionBody} />
          </article>

          {hasMedia && (
            <figure className={styles.figure}>
              <Media
                src={media.src}
                picture={media.picture}
                alt={media.alt || ''}
                objectPosition={media.position || 'center'}
                policy={MEDIA_POLICY_KEYS.SECTION_SPLIT}
                ratio='16 / 10'
                className={styles.media}
              />
              {media.caption && <figcaption>{media.caption}</figcaption>}
            </figure>
          )}

          {guide?.heading && (
            <aside className={styles.guide} aria-labelledby={guideHeadingId}>
              <div className={styles.guideHeading}>
                {guide.eyebrow && <span>{guide.eyebrow}</span>}
                <GuideHeading id={guideHeadingId}>{guide.heading}</GuideHeading>
                {guide.summary && <p>{guide.summary}</p>}
              </div>
              <ContentBlocks blocks={guide.body} className={styles.guideBody} />
            </aside>
          )}

          {supportingContent && (
            <div className={styles.supporting}>
              {supportingContent}
            </div>
          )}
        </div>
      </Container>
    </section>
  )
}

export default ServiceOverview
